import { drapcodeIcon } from '../../../common/custom/icon-library';

function route(version, projectId, segment, suffix) {
  const tail = suffix ? `/${suffix}` : '';
  return `/2.0/${segment}/${version}/v/${projectId}${tail}`;
}

export function getShellNavigation({ projectId, version, developerApiDomain }) {
  const org = process.env.REACT_APP_ORGANIZATION || '';
  const apiHost = developerApiDomain || '';

  const settingsChildren = [
    {
      id: 'app-setting',
      label: 'App Setting',
      icon: 'webconnect-home',
      to: route(version, projectId, 'app-setting', 'setting/app-config'),
      match: '/app-setting/',
    },
    // {
    //   id: 'custom-css',
    //   label: 'Custom CSS',
    //   icon: drapcodeIcon('customCSS'),
    //   to: route(version, projectId, 'app-setting', 'setting/custom-css'),
    // },
    // {
    //   id: 'custom-js',
    //   label: 'Custom JavaScript',
    //   icon: drapcodeIcon('customJS'),
    //   to: route(version, projectId, 'app-setting', 'setting/custom-js'),
    // },
    // {
    //   id: 'custom-component',
    //   label: 'Custom Component',
    //   icon: drapcodeIcon('customComponent'),
    //   to: route(version, projectId, 'custom-component', 'customComponent'),
    //   match: '/custom-component/',
    // },
    // {
    //   id: 'pwa',
    //   label: 'PWA Configuration',
    //   icon: drapcodeIcon('pwa'),
    //   to: route(version, projectId, 'app-setting', 'setting/pwa-config'),
    // },
    // {
    //   id: 'dev-key',
    //   label: 'Developer API',
    //   icon: drapcodeIcon('devKey'),
    //   to: route(version, projectId, 'app-setting', 'setting/devKey'),
    // },
    {
      id: 'encryption',
      label: 'Data Encryption',
      icon: drapcodeIcon('encryption'),
      to: route(version, projectId, 'app-setting', 'setting/encryption-section'),
    },
    // {
    //   id: 'templates',
    //   label: 'Templates',
    //   icon: 'webconnect-file-alt',
    //   to: route(version, projectId, 'template', ''),
    //   match: '/template/',
    // },
    // {
    //   id: 'data-source',
    //   label: 'Data Source',
    //   icon: 'webconnect-hdd-stack-fill',
    //   to: route(version, projectId, 'data-connector', ''),
    //   match: '/data-connector/',
    // },
    // {
    //   id: 'external-apis-settings',
    //   label: 'External APIs',
    //   icon: 'webconnect-rocket',
    //   to: route(version, projectId, 'externalapi', ''),
    //   match: '/externalapi/',
    // },
    // {
    //   id: 'localization',
    //   label: 'Localization',
    //   icon: 'webconnect-edit',
    //   to: route(version, projectId, 'app-setting', 'setting/localization-section'),
    // },
    // {
    //   id: 'logs',
    //   label: 'System Logs',
    //   icon: drapcodeIcon('logs'),
    //   to: route(version, projectId, 'logger', ''),
    //   match: '/logger/',
    // },
    // {
    //   id: 'schedule',
    //   label: 'Background Task',
    //   icon: drapcodeIcon('alarm'),
    //   to: route(version, projectId, 'schedule', ''),
    //   match: '/schedule/',
    // },
    {
      id: 'permissions',
      label: 'Delete Permissions',
      icon: drapcodeIcon('constants'),
      to: route(version, projectId, 'permission', ''),
      match: '/permission/',
    },
    // {
    //   id: 'code-export',
    //   label: 'Code Export',
    //   icon: drapcodeIcon('codeExport'),
    //   to: route(version, projectId, 'deployment-setting', 'code-export'),
    //   match: '/deployment-setting/',
    // },
    // {
    //   id: 'vibe-settings',
    //   label: 'Vibe Coding',
    //   icon: drapcodeIcon('vibeCoding'),
    //   to: route(version, projectId, 'vibe-coding', ''),
    //   match: '/vibe-coding/',
    // },
  ];

  return {
    groups: [
      // {
      //   id: 'general',
      //   label: 'General',
      //   items: [
      //     {
      //       id: 'dashboard',
      //       label: 'Dashboard',
      //       icon: 'webconnect-grid-fill',
      //       href: `${org}dashboard`,
      //       external: true,
      //     },
      //     {
      //       id: 'search',
      //       label: 'Search',
      //       icon: 'webconnect-search',
      //       action: 'search',
      //     },
      //   ],
      // },
      {
        id: 'build',
        label: 'Build',
        items: [
          {
            id: 'vibe',
            label: 'Code Editor',
            icon: drapcodeIcon('vibeCoding'),
            to: route(version, projectId, 'vibe-coding', 'chat'),
            match: '/vibe-coding/',
          },
          // {
          //   id: 'pages',
          //   label: 'Pages',
          //   icon: 'webconnect-file-alt',
          //   action: 'flyout',
          //   flyoutId: 'PAGES',
          // },
          // {
          //   id: 'components',
          //   label: 'Components',
          //   icon: 'webconnect-plus-square',
          //   action: 'editor',
          // },
          // {
          //   id: 'collections',
          //   label: 'Collections',
          //   icon: 'webconnect-database',
          //   action: 'flyout',
          //   flyoutId: 'COLLECTIONS',
          //   match: '/collections/',
          // },
          {
            id: 'collections',
            label: 'Collections',
            icon: 'webconnect-database',
            to: route(version, projectId, 'collections', ''),
            match: '/collections/',
          },
          // {
          //   id: 'snippets',
          //   label: 'Snippets',
          //   icon: 'webconnect-bars',
          //   action: 'flyout',
          //   flyoutId: 'TEMPLATES',
          // },
          // {
          //   id: 'assets',
          //   label: 'Assets',
          //   icon: 'webconnect-image_solid',
          //   action: 'editor',
          // },
        ],
      },
      {
        id: 'more',
        label: 'More',
        items: [
          // {
          //   id: 'events',
          //   label: 'Events',
          //   icon: 'webconnect-diagram-3-fill',
          //   action: 'flyout',
          //   flyoutId: 'EVENTS',
          //   match: '/events/',
          // },
          // {
          //   id: 'plugins',
          //   label: 'Plugins',
          //   icon: 'webconnect-tools',
          //   to: route(version, projectId, 'plugin', ''),
          //   match: '/plugin/',
          // },
          // {
          //   id: 'external-apis',
          //   label: 'External APIs',
          //   icon: 'webconnect-rocket',
          //   to: route(version, projectId, 'externalapi', ''),
          //   match: '/externalapi/',
          // },
          // {
          //   id: 'data-source-nav',
          //   label: 'Data Source',
          //   icon: 'webconnect-hdd-stack-fill',
          //   to: route(version, projectId, 'data-connector', ''),
          //   match: '/data-connector/',
          // },
          // {
          //   id: 'templates-nav',
          //   label: 'Templates',
          //   icon: 'webconnect-file-alt',
          //   to: route(version, projectId, 'template', ''),
          //   match: '/template/',
          // },
          {
            id: 'dev-key',
            label: 'Developer API',
            icon: drapcodeIcon('devKey'),
            to: route(version, projectId, 'app-setting', 'setting/devKey'),
            match: '/setting/devKey',
          },
          {
            id: 'api-usage',
            label: 'API Usage',
            icon: drapcodeIcon('logs'),
            to: route(version, projectId, 'app-setting', 'setting/api-usage'),
            match: '/setting/api-usage',
          },
        ],
      },
    ],
    footer: [
      {
        id: 'project',
        label: 'Project',
        icon: 'webconnect-file-ppt-fill',
        children: [
          {
            id: 'project-dashboard',
            label: 'Dashboard',
            icon: 'webconnect-grid-fill',
            href: `${org}dashboard`,
            external: true,
          },
          {
            id: 'project-settings',
            label: 'Settings',
            icon: 'webconnect-gear',
            href: `${org}${projectId}/project-detail`,
            external: true,
          },
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: 'webconnect-cogs',
        children: settingsChildren,
      },
      // {
      //   id: 'tutorials',
      //   label: 'Tutorials',
      //   icon: 'webconnect-youtube',
      //   action: 'tutorials',
      // },
      {
        id: 'help',
        label: 'Help',
        icon: 'webconnect-info-circle',
        children: [
          {
            id: 'manual',
            label: 'Product Manual',
            icon: 'webconnect-file-alt',
            href: 'https://academy.drapcode.com/',
            external: true,
          },
          {
            id: 'dev-api-docs',
            label: 'Developer API',
            icon: 'webconnect-rocket',
            href: `https://${apiHost}.drapcode.io/api/v1/docs`,
            external: true,
          },
          {
            id: 'mcp-docs',
            label: 'Drapcode MCP',
            icon: 'webconnect-tools',
            href: `https://${apiHost}.drapcode.io/api/v1/mcp/docs`,
            external: true,
          },
          {
            id: 'contact',
            label: 'Need Help?',
            icon: 'webconnect-envelope',
            href: 'https://drapcode.com/contact-us',
            external: true,
          },
          {
            id: 'slack',
            label: 'Slack Community',
            icon: 'webconnect-slack',
            href: 'https://join.slack.com/t/drapcode/shared_invite/zt-xvo04sdw-Whf_4z3KsWTu1wd8R_6rYQ',
            external: true,
          },
          {
            id: 'discord',
            label: 'Discord Community',
            icon: 'webconnect-discord',
            href: 'https://discord.com/channels/844860999542898708/844861000510734358',
            external: true,
          },
          {
            id: 'community',
            label: 'Community',
            icon: 'webconnect-address-card',
            href: 'https://community.drapcode.com/',
            external: true,
          },
          {
            id: 'youtube',
            label: 'Tutorials',
            icon: 'webconnect-youtube',
            href: 'https://www.youtube.com/channel/UCGQQj8iNARSHscemk9FY5uw',
            external: true,
          },
          {
            id: 'feature-request',
            label: 'Feature Request?',
            icon: 'webconnect-edit-solid',
            href: 'https://typeform229411.typeform.com/to/ZnBQ7y6u',
            external: true,
          },
        ],
      },
    ],
  };
}

export function isNavItemActive(pathname, item) {
  if (!item || !item.match || !pathname) return false;
  return pathname.indexOf(item.match) !== -1;
}
